import React, { useEffect } from 'react'
import { ScalesReadingState } from '../../../../../core/store/scalesReading/latestScalesReadingState'
import {
  MAX_MS_SINCE_LAST_READING,
  MAX_SCALES_READINGS,
  MIN_STABILIZATION_SCALES_READINGS,
  SCALES_READING_VALUE_UPDATE_THRESHOLD_G,
  ZERO_MASS_THRESHOLD_G,
} from '../../../../../utils/constants'

export const useStableWeightWs = (
  stableReadingG: number,
  setStableReadingG: React.Dispatch<number>,
  predictionDataLock: boolean,
  setPredictionDataLock: React.Dispatch<boolean>,
  setPredictionDataHandler: (clear?: boolean) => void,
  {
    isValid,
    numReadingsSinceUpdate,
    reading: { createdAt, value },
  }: ScalesReadingState,
) => {
  useEffect(() => {
    const isReadingRecent = Date.now() - createdAt <= MAX_MS_SINCE_LAST_READING
    const isReadingUsable = isValid && isReadingRecent
    const isReadingStable =
      numReadingsSinceUpdate % MIN_STABILIZATION_SCALES_READINGS ===
        MIN_STABILIZATION_SCALES_READINGS - 1 ||
      numReadingsSinceUpdate === MAX_SCALES_READINGS

    if (!isReadingUsable || !isReadingStable || predictionDataLock) {
      return
    }
    const readingJson = JSON.stringify(
      {
        isValid,
        numReadingsSinceUpdate,
        reading: { createdAt, value },
        predictionDataLock,
        stableReadingG,
      },
      null,
      2,
    )

    if (
      Math.abs(value - stableReadingG) <=
      SCALES_READING_VALUE_UPDATE_THRESHOLD_G
    ) {
      return
    }

    setPredictionDataLock(true)

    if (value <= ZERO_MASS_THRESHOLD_G) {
      console.debug(
        `PredictionData: zero stabilized reading (current ${readingJson}))`,
      )
      setPredictionDataHandler(true)
      setStableReadingG(0)
      return
    }
    console.debug(
      `PredictionData: stabilized reading (current ${readingJson}))`,
    )
    setStableReadingG(value)
    setPredictionDataHandler()
  }, [
    createdAt,
    isValid,
    value,
    numReadingsSinceUpdate,
    setPredictionDataHandler,
    predictionDataLock,
    setPredictionDataLock,
    stableReadingG,
    setStableReadingG,
  ])
}
